import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Typography,
  Box,
  TextField,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface CategoryFormDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: (name: string) => void
  initialName?: string
  isEdit?: boolean
}

const CategoryFormDialog: React.FC<CategoryFormDialogProps> = ({
  open,
  onClose,
  onConfirm,
  initialName = '',
  isEdit = false,
}) => {
  const { t } = useTranslation('cost')
  const [name, setName] = useState(initialName)

  useEffect(() => {
    setName(initialName)
  }, [initialName, open])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 3,
          px: 1,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1,
        }}
      >
        {isEdit ? t('edit.name.category') : t('add.new.category')}

        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Stack spacing={1.5}>
          <Typography fontWeight={600}>
            <Box component="span" color="error.main" mr={0.5}>
              *
            </Box>
            {t('category.name')}
          </Typography>

          <TextField
            autoFocus
            fullWidth
            size="small"
            placeholder={t('category.name.placeholder')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 2,
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          sx={{
            borderRadius: 1,
          }}
        >
          {t('form.cancel')}
        </Button>

        <Button
          variant="contained"
          color="primary"
          disabled={!name.trim()}
          onClick={() => onConfirm(name)}
          sx={{
            borderRadius: 1,
            '&:hover': {
              backgroundColor: '#15803d',
            },
          }}
        >
          {t('form.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CategoryFormDialog